<template>
  <div>
    <div
      class="backdrop"
      v-if="isOpen"
      @click="$emit('close')"
    ></div>
    <div
      class="sidebar"
      :class="[side, { open: isOpen }]"
      @click.stop
      @touchstart="handleTouchStart"
      @touchend="handleTouchEnd"
    >
      <slot></slot>
    </div>
  </div>
</template>

<script>


export default {
  name: 'AppSidebar',
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    side: {
      type: String,
      default: 'left',
      validator(value) {
        return ['left', 'right'].includes(value)
      },
    },
  },
  data() {
    return {
      touchStartX: 0,
    }
  },
  watch: {
    isOpen(newValue) {
      document.body.style.overflow = newValue ? 'hidden' : ''
    }
  },
  methods: {
    handleTouchStart(event) {
      this.touchStartX = event.touches[0].clientX
    },
    handleTouchEnd(event) {
      const touchEndX = event.changedTouches[0].clientX
      const swipeDistance = touchEndX - this.touchStartX
      const threshold = 50

      if (Math.abs(swipeDistance) > threshold) {
        if (this.side === 'left' && swipeDistance < 0) {
          this.$emit('close')
        } else if (this.side === 'right' && swipeDistance > 0) {
          this.$emit('close')
        }
      }

      this.resetTouchData()
    },
    resetTouchData() {
      this.touchStartX = 0
    },
  },
}
</script>
